module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.matters), function(m) {
    return _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column col-5"
    }, [_c('router-link', {
      attrs: {
        "to": '/matters/' + m._id
      }
    }, [_vm._v(_vm._s(m.mattername))])], 1), _vm._v(" "), _c('div', {
      staticClass: "column col-5"
    }, [_vm._v("\n      Due " + _vm._s(new Date(m.due).toDateString()) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "column col-2"
    }, [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.del(m)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b70e33a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/matters/clientMatters.vue
// module id = 510
// module chunks = 1